module.exports = __webpack_public_path__ + "img/8.cc17b68f.jpg";